import { render, staticRenderFns } from "./ImageEditionView.vue?vue&type=template&id=08e9666d"
import script from "./ImageEditionView.vue?vue&type=script&lang=js"
export * from "./ImageEditionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports